var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-primary text-center"},[_vm._v(" "+_vm._s(_vm.$t('question') + ' ' + _vm.questionNum + '/' + _vm.totalQuestions + (_vm.time ? ' | ' + _vm.$t('timeRemaining') + ': ' + _vm.readableTime : ''))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }